import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { backUrl } from '../config';

const redPath = 'organizationApi'; // change
const tagApi = 'organizations'; // change

export const organizationApi = createApi({
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getOrganization: build.query({
      query: (param) => `${tagApi}/1${param ? param : ''}`,
      providesTags: [tagApi],
    }),
    updateOrganization: build.mutation({
      query: (updates) => ({
        url: `organizations/1`,
        method: 'PUT',
        body: {
          data: {
            ...updates,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetOrganizationQuery,
  useAddOrganizationMutation,
  useUpdateOrganizationMutation,
} = organizationApi;
